import * as React from 'react';
/**
 *
 * Original name: camera upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A333
 *
 */
export const CameraUploadPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M48 47a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V23h9.731l3.429-6h11.679l1.427 2.5 3.473-1.984L37.161 13H20.84l-3.429 6H6v28a6.007 6.007 0 0 0 6 6h34a6.007 6.007 0 0 0 6-6V32h-4v15Z", fill: "currentColor" }),
    React.createElement("path", { d: "M19 35c0 6.355 3.645 10 10 10s10-3.645 10-10-3.645-10-10-10-10 3.645-10 10Zm16 0c0 4.149-1.851 6-6 6s-6-1.851-6-6 1.851-6 6-6 6 1.851 6 6Zm17-25h-4a11.352 11.352 0 0 1-5.895 6.211l1.789 3.578A16.775 16.775 0 0 0 48 16.926V28h4V16.926a16.774 16.774 0 0 0 4.105 2.864l1.789-3.578A11.347 11.347 0 0 1 52 10Z", fill: "currentColor" })));
